import moment from 'moment';
import { BulletinType } from 'services/interfaces/installation/bulletin';

export const resendDateError = (date: string, type: BulletinType) => {
  if (!date) return 'Informe a data';
  if (type === 'WEEKLY' && moment(date, 'YYYY-MM-DD').isoWeekday() !== 1)
    return 'Para boletim semanal, escolha uma segunda-feira';
  return null;
};
